import React, { FC, ReactNode } from 'react';

interface TableProps {
  children: ReactNode;
  className?: string;
}

const Table: FC<TableProps> = ({ children, className = '' }) => {
  return (
    <table className={`min-w-full bg-white border border-gray-200 ${className}`}>
      {children}
    </table>
  );
};

export default Table;
